let logoutFunction = null;

export const setLogoutFunction = (logout) => {
    logoutFunction = logout;
};

export const getLogoutFunction = () => logoutFunction;